import StringResult from '@/core/models/StringResult';
import EnvironmentVariableConstants from '../../environment-variable/constants/EnvironmentVariableConstants';
import EnvironmentVariable from '../../environment-variable/facades/EnvironmentVariable';
import PriceFactory from '../factories/PriceFactory';
import PriceRepositoryInterface from '../interface-adapters/PriceRepositoryInterface';
import FormatPriceViewModel from '../view-models/FormatPriceViewModel';

export default class FormatPriceUseCase {
    private priceRepo: PriceRepositoryInterface;
    private env: EnvironmentVariable;

    public constructor() {
        this.priceRepo = PriceFactory.makeRepo();
        this.env = EnvironmentVariable.getInstance();
    }

    public invoke(model: FormatPriceViewModel) {
        let result = new StringResult();
        const validateResult = model.validate();
        if (validateResult.success === false) {
            result = result.copyExceptData(validateResult);
            return result;
        }

        const currency = this.env.get(EnvironmentVariableConstants.VITE_CURRENCY);

        const formatResult = this.priceRepo.format(model.price, currency, model.defaultText);

        result = result.copyExceptData(formatResult);
        result.data = formatResult.data;

        return result;
    }
}
